var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#000",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 8.706l-2.79 2.792-.708-.707 2.791-2.792-2.79-2.79.707-.707 2.79 2.79L10.791 4.5l.707.707L8.706 8l2.793 2.794-.707.707-2.794-2.794z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMTYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljk5ODQ4IDguNzA2NDJMNS4yMDcxMSAxMS40OTc4TDQuNSAxMC43OTA3TDcuMjkxMzcgNy45OTkzMUw0LjUwMTEyIDUuMjA5MDZMNS4yMDgyMyA0LjUwMTk1TDcuOTk4NDggNy4yOTIyTDEwLjc5MDcgNC41TDExLjQ5NzggNS4yMDcxMUw4LjcwNTU4IDcuOTk5MzFMMTEuNDk4OSAxMC43OTI2TDEwLjc5MTggMTEuNDk5N0w3Ljk5ODQ4IDguNzA2NDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCloseCircle as ReactComponent };